import { GoogleLogin } from "@react-oauth/google";
import { authAPI } from "../api/client";
import { useNavigate } from "react-router-dom";
import '../pages/AnimationsAndStyles.css';

export default function Login({ onLoginSuccess }) {
  const navigate = useNavigate();

  const handleLogin = async (res) => {
    try {
      const response = await authAPI.googleLogin(res.credential);

      // 🔹 FIRST LOGIN → SHOW QR
      if (response.data.setup2FA) {
        localStorage.setItem("pendingUserId", response.data.userId);
        localStorage.setItem("qrCode", response.data.qrCode);
        localStorage.setItem("manualKey", response.data.manualKey);

        navigate("/setup-2fa");
        return;
      }

      // 🔹 EXISTING USER → OTP
      if (response.data.requireOTP) {
        localStorage.setItem("pendingUserId", response.data.userId);
        navigate("/otp");
        return;
      }

      // 🔹 DIRECT LOGIN
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        onLoginSuccess();
        navigate("/");
      }

    } catch (err) {
      console.error("Login failed", err);
    }
  };

  return (
    <div style={styles.pageContainer}>
      <style>{css}</style>
      
      <div style={styles.bgShapes}>
        <div style={styles.bgShape1}></div>
        <div style={styles.bgShape2}></div>
      </div>

      <div style={styles.contentWrapper}>
        <div style={styles.logoSection}>
          <div style={styles.logoIcon}>👔</div>
          <h1 style={styles.logoText}>HR Management System</h1>
          <p style={styles.logoSubtext}>Professional Recruitment Platform</p>
        </div>

        <div style={styles.loginCard}>
          <div style={styles.formContent}>
            <h2 style={styles.title}>Welcome Back</h2>
            <p style={styles.subtitle}>Sign in with your Google account to continue</p>

            <div style={styles.googleLoginWrapper}>
              <GoogleLogin onSuccess={handleLogin} />
            </div>

            <div style={styles.divider}></div>

            <p style={styles.footerText}>
              💡 Secure login powered by Google OAuth 2.0
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0F172A 0%, #1E3A8A 50%, #0EA5E9 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: "'Inter', sans-serif",
    position: 'relative',
    overflow: 'hidden',
  },
  bgShapes: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 0,
    opacity: 0.1,
  },
  bgShape1: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.2)',
    top: '-100px',
    left: '-100px',
    animation: 'float 6s ease-in-out infinite',
  },
  bgShape2: {
    position: 'absolute',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.15)',
    bottom: '-50px',
    right: '-50px',
    animation: 'float 8s ease-in-out infinite 1s',
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '500px',
    width: '100%',
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: '40px',
    animation: 'fadeInDown 0.6s ease-out',
  },
  logoIcon: {
    fontSize: '56px',
    marginBottom: '16px',
    display: 'inline-block',
    animation: 'rotateIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  logoText: {
    fontSize: '28px',
    fontWeight: 700,
    color: 'white',
    margin: '12px 0',
    fontFamily: "'Poppins', sans-serif",
  },
  logoSubtext: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.8)',
    margin: 0,
  },
  loginCard: {
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden',
    animation: 'scaleIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
    position: 'relative',
  },
  formContent: {
    padding: '40px',
  },
  title: {
    fontSize: '26px',
    fontWeight: 700,
    color: '#0F172A',
    margin: '0 0 8px 0',
    fontFamily: "'Poppins', sans-serif",
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748B',
    margin: '0 0 28px 0',
  },
  googleLoginWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  divider: {
    height: '1px',
    background: '#E2E8F0',
    margin: '24px 0',
  },
  footerText: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#94A3B8',
    margin: 0,
  },
};

const css = `
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes rotateIn {
    from {
      opacity: 0;
      transform: rotate(-10deg) scale(0.9);
    }
    to {
      opacity: 1;
      transform: rotate(0deg) scale(1);
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

// import { GoogleLogin } from "@react-oauth/google";
// import { authAPI } from "../api/client";
// import { useNavigate } from "react-router-dom";

// export default function Login({ onLoginSuccess }) {
//   const navigate = useNavigate();

//   const handleLogin = async (res) => {
//     try {
//       const response = await authAPI.googleLogin(res.credential);

//       // 🔹 FIRST-TIME LOGIN → SETUP 2FA
//       if (response.data.setup2FA) {
//         // 🔥 THIS IS CRITICAL
//         localStorage.setItem(
//           "pendingUserId",
//           String(response.data.userId)
//         );

//         alert(
//           `Add this key to Google Authenticator:\n\n${response.data.manualKey}`
//         );

//         navigate("/otp");
//         return;
//       }

//       // 🔹 EXISTING USER → OTP REQUIRED
//       if (response.data.requireOTP) {
//         localStorage.setItem(
//           "pendingUserId",
//           String(response.data.userId)
//         );

//         navigate("/otp");
//         return;
//       }

//       // 🔹 DIRECT LOGIN
//       if (response.data.token) {
//         localStorage.setItem("token", response.data.token);
//         onLoginSuccess();
//         navigate("/");
//       }

//     } catch (err) {
//       console.error("Login failed", err);
//     }
//   };

//   return (
//     <div className="card">
//       <h2>HR Login</h2>
//       <GoogleLogin onSuccess={handleLogin} />
//     </div>
//   );
// }

// // import { GoogleLogin } from "@react-oauth/google";
// // import { authAPI } from "../api/client";
// // import { useNavigate } from "react-router-dom";

// // export default function Login({ onLoginSuccess }) {
// //   const navigate = useNavigate();

// //   const handleLogin = async (res) => {
// //     try {
// //       const response = await authAPI.googleLogin(res.credential);

// //       // 🔹 First-time login → setup Authenticator
// //       if (response.data.setup2FA) {
// //         // store pending userId for OTP
// //         localStorage.setItem("pendingUserId", response.data.userId);

// //         alert(
// //           `Add this key to Google Authenticator:\n\n${response.data.manualKey}`
// //         );

// //         // 👉 go to OTP screen
// //         navigate("/otp");
// //         return;
// //       }

// //       // 🔹 Login success → go to dashboard
// //       if (response.data.token) {
// //         localStorage.setItem("token", response.data.token);
// //         onLoginSuccess();
// //         navigate("/");
// //       }

// //     } catch (err) {
// //       console.error("Login failed", err);
// //     }
// //   };

// //   return (
// //     <div className="card">
// //       <h2>HR Login</h2>

// //       <GoogleLogin
// //         onSuccess={handleLogin}
// //         onError={() => console.log("Login Failed")}
// //       />
// //     </div>
// //   );
// // }

// // // import { GoogleLogin } from "@react-oauth/google";
// // // import { authAPI } from "../api/client";

// // // export default function Login({ onLoginSuccess }) {

// // //   const handleLogin = async (res) => {
// // //     const response = await authAPI.googleLogin(res.credential);

// // //     // 🔹 First time login → setup Authenticator
// // //     if (response.data.setup2FA) {
// // //       alert(
// // //         `Add this key to Google Authenticator:\n\n${response.data.manualKey}`
// // //       );
// // //       return;
// // //     }

// // //     // 🔹 Already enabled → direct login
// // //     if (response.data.token) {
// // //       localStorage.setItem("token", response.data.token);
// // //       onLoginSuccess();
// // //     }
// // //   };

// // //   return (
// // //     <div className="card">
// // //       <h2>HR Login</h2>
// // //       <GoogleLogin onSuccess={handleLogin} />
// // //     </div>
// // //   );
// // // }

// // // // import { GoogleLogin } from "@react-oauth/google";
// // // // import { authAPI } from "../api/client";

// // // // export default function Login({ onLoginSuccess }) {

// // // //   const handleLogin = async (res) => {
// // // //     try {
// // // //       const response = await authAPI.googleLogin(res.credential);

// // // //       if (response.data.token) {
// // // //         localStorage.setItem("token", response.data.token);
// // // //         onLoginSuccess(); // 🔑 Bridge to old App logic
// // // //       }

// // // //       if (response.data.requireOTP) {
// // // //         alert("OTP step pending – next step to wire");
// // // //       }

// // // //     } catch (err) {
// // // //       console.error("Login failed", err);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div className="card">
// // // //       <h2>HR Login</h2>
// // // //       <GoogleLogin
// // // //         onSuccess={handleLogin}
// // // //         onError={() => console.log("Login Failed")}
// // // //       />
// // // //     </div>
// // // //   );
// // // // }

// // // // // import { GoogleLogin } from "@react-oauth/google";
// // // // // import { authAPI } from '../api/client';

// // // // // export default function Login({ setAuthStep, setUserId, setManualKey }) {

// // // // //   const handleLogin = async (res) => {
// // // // //     try {
// // // // //       const response = await authAPI.googleLogin(res.credential);

// // // // //       if (response.data.requireOTP) {
// // // // //         setUserId(response.data.userId);
// // // // //         setAuthStep("otp");
// // // // //       }

// // // // //       if (response.data.setup2FA) {
// // // // //         setUserId(response.data.userId);
// // // // //         setManualKey(response.data.manualKey);
// // // // //         setAuthStep("setup");
// // // // //       }
// // // // //     } catch (err) {
// // // // //       console.error("Login failed", err);
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <div className="card">
// // // // //       <h2>HR Login</h2>
// // // // //       <GoogleLogin onSuccess={handleLogin} />
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // // import React, { useState } from 'react';

// // // // // // export default function Login({ onLogin }) {
// // // // // //   const [username, setUsername] = useState('');
// // // // // //   const [password, setPassword] = useState('');
// // // // // //   const [error, setError] = useState('');

// // // // // //   const handleSubmit = (e) => {
// // // // // //     e.preventDefault();
// // // // // //     // Simple static check; replace with real auth as needed
// // // // // //     if (username === 'admin' && password === 'admin') {
// // // // // //       onLogin();
// // // // // //     } else {
// // // // // //       setError('Invalid credentials');
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
// // // // // //       <h2>Login</h2>
// // // // // //       <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: 300 }}>
// // // // // //         <input
// // // // // //           type="text"
// // // // // //           placeholder="Username"
// // // // // //           value={username}
// // // // // //           onChange={e => setUsername(e.target.value)}
// // // // // //           style={{ marginBottom: 10, padding: 8 }}
// // // // // //         />
// // // // // //         <input
// // // // // //           type="password"
// // // // // //           placeholder="Password"
// // // // // //           value={password}
// // // // // //           onChange={e => setPassword(e.target.value)}
// // // // // //           style={{ marginBottom: 10, padding: 8 }}
// // // // // //         />
// // // // // //         <button type="submit" style={{ padding: 8 }}>Login</button>
// // // // // //         {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
// // // // // //       </form>
// // // // // //     </div>
// // // // // //   );
// // // // // // }
